<input class="upload-input" multiple type="file" accept="{{this.selfSchedulingDocumentAcquisitionService.acceptedFileFormatString}}"
       (change)="this.selfSchedulingDocumentAcquisitionService.handleAcquiredDocument($event.target.files)"
       #fileInput>
<cp-button-widget-custom class="secondary-button upload-button call-to-action"
                         iconName="pp-icon-patient_forms"
                         captionToTranslate="ClickAddDocuments"
                         (onClick)="fileInput.click()"
                         [disabled]="maxUploadSizeReached">
</cp-button-widget-custom>
<span class="disclaimer-label">{{"MaxUploadSizeInParam" | cpMessageTranslate: [maxFileSizeValueLabel] | async}}</span>
<div class="doc-list-title" *ngIf="acquiredDocList && acquiredDocList.length > 0">
  <div>{{"DocumentsToUpload" | cpTitleTranslate | async}}:</div>
</div>
<div class="acquired-document-list" *ngIf="acquiredDocList && acquiredDocList.length > 0">
  <div class="acquired-document" *ngFor="let doc of acquiredDocList" [class.invalid]="doc.validationState > 0">
    <div class="doc-icon">
      <i *ngIf="doc.validationState === 0" class="pp-icon-status_confirm"></i>
      <i *ngIf="doc.validationState > 0" class="pp-icon-error"></i>
    </div>
    <div class="doc-icon">
      <i class="pp-icon-patient_forms"></i>
    </div>
    <div class="acquired-document-name">{{doc.name}}&nbsp;</div>
    <div *ngIf="doc.validationState === 0" class="acquired-document-size">({{this.getFileSizeValueLabel(doc.size)}})</div>
    <div class="btn-delete-document" [class.invalid]="doc.validationState > 0" (click)="selfSchedulingDocumentAcquisitionService.deleteDocument(doc.index)">
      <i class="pp-icon-cancel"></i>
    </div>
    <div *ngIf="doc.validationState === 2" class="card-error-label">{{"IncorrectFormat" | cpMessageTranslate | async}}</div>
  </div>
</div>
<div class="form-error">
  <div *ngIf="acquiredDocList && acquiredDocList.length && maxUploadSizeReached" class="form-error-label">
    {{"totalSizeExceeded" | cpMessageTranslate: [maxFileSizeValueLabel] | async}}
  </div>
</div>
